import { BreadcrumbItem, H1 } from '@payaca/ambrosia';
import { FC, PropsWithChildren, type JSX } from 'react';

import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import PaginationControl from '@payaca/components/paginationControl/PaginationControl';

import './ListViewPageWrapper.sass';

type Props = {
  className?: string;
  title?: string | JSX.Element;
  paginationConfig?: {
    pageNumber: number;
    totalItemCount: number;
    pageSize: number;
    allowPageSizeSelection?: boolean;
    availablePageSizes?: number[];
    onSelectPage: (pageNumber: number) => void;
    onSelectPageSize?: (pageSize: number) => void;
  };
  breadcrumbItems?: BreadcrumbItem[];
};
const ListViewPageWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  title,
  paginationConfig,
  breadcrumbItems,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <AuthenticatedPageWrapper
      breadcrumbItems={breadcrumbItems}
      className={`list-view-page-wrapper ${className ? className : ''}`}
    >
      {title && (
        <div className="flex min-h-16 items-center px-8 py-4">
          {typeof title === 'string' ? <H1>{title}</H1> : title}
        </div>
      )}
      <div className="list-view-content">{children}</div>
      {paginationConfig && (
        <div className="pagination-control-container">
          <PaginationControl {...paginationConfig} />
        </div>
      )}
    </AuthenticatedPageWrapper>
  );
};

export default ListViewPageWrapper;
